import React from 'react'

import { Layout } from 'components'

import { ProductsList } from 'modules/Products/containers'

const ProductsPage = () => (
  <Layout>
    <ProductsList />
  </Layout>
)

export default ProductsPage
